import React from "react";
import { useSelector } from "react-redux";
import {
  selectAuthenticated,
  selectSubscribed,
  selectSubscriptionLevel,
} from "../../selectors";
import { PaymentsPreview } from "./preview";
import { ManagePremium } from "./manage-premium";
import { Redirect } from "react-router";

export const PremiumPage = () => {
  const authenticated = useSelector(selectAuthenticated);
  const subscriptionLevel = useSelector(selectSubscriptionLevel);
  const subscribed = useSelector(selectSubscribed);

  if (authenticated && subscriptionLevel === "full_access") {
    return <ManagePremium />;
  }

  if (authenticated && subscribed) {
    return <PaymentsPreview authenticated={authenticated} />;
  }

  return <Redirect to="/" />;
};
